import uuid from 'react-uuid';
import { FundInvestmentDetail } from 'pages/FundInvestments';
import { GetFundInvestmentByAllocationReturn } from 'services/hooks/fundInvestments';
import { getArrayValue, getObjectValue } from 'utilities';

const parseFundInvestmentDetails = (
  fundInvestmentByAllocation: GetFundInvestmentByAllocationReturn['data']
): FundInvestmentDetail[] =>
  getArrayValue(fundInvestmentByAllocation).map(fundInvestment => {
    const {
      capital_account_date: capitalAccountDate,
      commited_capital: commitedCapital,
      concluded_fair_value_of_net_capital: concludedFairValueOfNetCapital,
      distributions,
      fund_investment_ownership: fundInvestmentOwnership,
      fund,
      id,
      invested_capital: investedCapital,
      market_adjustment: marketAdjustment,
      net_capital: netCapital,
      realized_income: realizedIncome,
      unrealized_income: unrealizedIncome,
    } = getObjectValue(fundInvestment);

    const { id: fundId } = getObjectValue(fund);

    return {
      capital_account_date: capitalAccountDate,
      commited_capital: commitedCapital,
      concluded_fair_value_of_net_capital: concludedFairValueOfNetCapital,
      distributions,
      fund_investment_ownership: fundInvestmentOwnership,
      fund: fundId,
      id,
      invested_capital: investedCapital,
      market_adjustment: marketAdjustment,
      net_capital: netCapital,
      realized_income: realizedIncome,
      unrealized_income: unrealizedIncome,
      uuid: uuid(),
    } as FundInvestmentDetail;
  });

export default parseFundInvestmentDetails;
